import { render, staticRenderFns } from "./CustomerValidationCard.vue?vue&type=template&id=cfe4f994&scoped=true&"
import script from "./CustomerValidationCard.vue?vue&type=script&lang=js&"
export * from "./CustomerValidationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe4f994",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/forge/demo.ec-direct.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfe4f994')) {
      api.createRecord('cfe4f994', component.options)
    } else {
      api.reload('cfe4f994', component.options)
    }
    module.hot.accept("./CustomerValidationCard.vue?vue&type=template&id=cfe4f994&scoped=true&", function () {
      api.rerender('cfe4f994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/CustomerValidationCard.vue"
export default component.exports